export var Experiences = /*#__PURE__*/function (Experiences) {
  Experiences["RENDER_NOTIFICATIONS_WITHOUT_CONTENT"] = "notification-list-render-notifications-without-content";
  Experiences["RENDER_NOTIFICATIONS_WITH_CONTENT"] = "notification-list-render-notifications-with-content";
  Experiences["RENDER_NOTIFICATION_PAGE_WITH_CONTENT"] = "notification-list-render-notification-page-with-content";
  Experiences["RENDER_INDIVIDUAL_NOTIFICATION_WITH_CONTENT"] = "notification-list-render-individual-notification-with-content";
  Experiences["ADD_REACTION_IN_CONTEXT"] = "react-reply-bar-add-reaction-in-context";
  Experiences["DELETE_REACTION_IN_CONTEXT"] = "react-reply-bar-delete-reaction-in-context";
  Experiences["FETCH_REACTION_SUMMARY_IN_CONTEXT"] = "react-reply-bar-fetch-reaction-summary-in-context";
  Experiences["COMMENT_REPLY_IN_CONTEXT"] = "react-reply-bar-comment-reply-in-context";
  Experiences["FETCH_COMMENT_DATA_IN_CONTEXT"] = "react-reply-bar-fetch-comment-data-in-context";
  Experiences["FETCH_JIRA_COMMENT_DATA_IN_CONTEXT"] = "jira-react-bar-fetch-comment-data-in-context";
  Experiences["JIRA_COMMENT_REPLY_IN_CONTEXT"] = "jira-reply-bar-comment-reply-in-context";
  Experiences["FETCH_USER_PREFERENCES_IN_CONTEXT"] = "comment-editor-fetch-user-preferences-in-context";
  Experiences["WATCH_CONTENT_IN_CONTEXT"] = "comment-editor-watch-content-in-context";
  return Experiences;
}({});
export var ExperienceIds = /*#__PURE__*/function (ExperienceIds) {
  ExperienceIds["FIRST_LOAD"] = "first-load";
  return ExperienceIds;
}({});
export var AbortReason = /*#__PURE__*/function (AbortReason) {
  AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
  AbortReason["CHANGE_FILTER"] = "change-filter";
  AbortReason["NO_DOCUMENTS"] = "no-adf-documents";
  AbortReason["CLIENT_ERROR"] = "client-error";
  return AbortReason;
}({});

/**
 * each mark has start/end
 */
export var NotificationExperienceMarkKeys = /*#__PURE__*/function (NotificationExperienceMarkKeys) {
  NotificationExperienceMarkKeys["API_WITHOUT_CONTENT"] = "apiWithoutContent";
  NotificationExperienceMarkKeys["API_WITH_CONTENT"] = "apiWithContent";
  NotificationExperienceMarkKeys["NOTIFICATIONS_INITIAL_MOUNT"] = "notificationsInitialMount";
  NotificationExperienceMarkKeys["NOTIFICATIONS_FEED_SKELETON_MOUNT"] = "notificationsFeedSkeletonMount";
  NotificationExperienceMarkKeys["NOTIFICATION_LIGHTWEIGHT_RENDER"] = "notificationsLightweightRender";
  NotificationExperienceMarkKeys["REACTIONS_AGG_CALLS"] = "reactionsAggCalls";
  NotificationExperienceMarkKeys["COMMENTS_AGG_CALLS"] = "commentsAggCalls";
  return NotificationExperienceMarkKeys;
}({});